{
    "ChanneltypesLabel": "Kanaltyp(en):",
    "ChanneltypesOptionAny": "[Jeder Kanal]",
    "ChanneltypesOptionVoice": "Sprachanrufe",
    "ChanneltypesOptionChat": "Chats",
    "ChanneltypesOptionEmail": "E-Mails",
    "CalltypedirectionLabel": "Anruftyp \/ Richtung:",
    "CalltypedirectionOptionAny": "[Jeder Anruftyp]",
    "CalltypedirectionOptionUnknownorinitiating": "[Unbekannt oder initiierend]",
    "CalltypedirectionOptionInbound": "Nur eingehend",
    "CalltypedirectionOptionOutbound": "Nur ausgehend",
    "CalltypedirectionOptionExternalAll": "Nur extern",
    "CalltypedirectionOptionExternalInbound": "Extern (nur eingehend)",
    "CalltypedirectionOptionExternalOutbound": "Extern (nur ausgehend)",
    "CalltypedirectionOptionExternalTrktotrk": "Externer Trunk-to-Trunk",
    "CalltypedirectionOptionInternalAll": "Nur intern",
    "CalltypedirectionOptionInternalInbound": "Intern (nur eingehend)",
    "CalltypedirectionOptionInternalOutbound": "Intern (nur ausgehend)",
    "AnswertypeLabel": "Antworttyp:",
    "ClicalleridreceivedAny": "[Any]",
    "ClicalleridreceivedNone": "Ohne CLI\/CallerID",
    "ClicalleridreceivedReceived": "Mit CLI\/CallerID",
    "AnswertypeOptionAny": "[Jeder Antworttyp]",
    "AnswertypeOptionNotans": "Nicht beantwortet",
    "AnswertypeOptionAns": "Antwortete",
    "AnswertypeOptionAbandoned": "Verlassen",
    "AnswertypeOptionAdvancedFrom": "Erweitert von",
    "AnswertypeOptionAdvancedTo": "Erweitert zu",
    "AnswertypeOptionOverflowedFrom": "Überlauf Aus",
    "AnswertypeOptionOverflowedTo": "Eingelaufen",
    "ClicalleridreceivedLabel": "CLI \/ Anrufer-ID erhalten:",
    "DiddigitsLabel": "DDI-Ziffern:",
    "AccountcodesLabel": "Kontocode(s):",
    "CallidentifierLabel": "Call Identifier (Telefonieplattform):",
    "SubjectfilterLabel": "Themenfilter:",
    "TreatconfcallasExternalLabel": "Telefonkonferenz als extern behandeln:",
    "MiscellaneousFiltering_SectionHeader": "Verschiedenes Filtern",
    "MiscellaneousFiltering_AnyPlaceholder": "[Any]",
    "NAME": "MiscellaneousFiltering"
}